import { NgModule, } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HomeComponent } from './components/home/home.component';
import { BilldetailsComponent } from './ebillcomponents/billdetails/billdetails.component';
import { FeedbackComponent } from './feedbackcomponents/feedback/feedback.component';
import { QrhomeComponent } from './scanordercomponents/qrhome/qrhome.component';
import { DemohomeComponent } from './demo/demohome/demohome.component';
import { AppSettings } from './services/constants/constants';
import { OrdersComponent } from './scanordercomponents/orders/orders.component';
import { PendingChangesGuard } from './components/PendingChangesGuard';
import { ProfileqrComponent } from './components/profileqr/profileqr.component';
import { LoyallofeedbackComponent } from './components/loyallofeedback/loyallofeedback.component';
import { CsprofileqrComponent } from './components/csprofileqr/csprofileqr.component';

// , runGuardsAndResolvers: 'always'

var emenuRountes: Routes = [
  { path: ':urlname/:tsname', component: HomeComponent },
  { path: ':urlname', component: HomeComponent },
]


var ebillRountes: Routes = [
  { path: ':urlname', component: BilldetailsComponent },
]

var feedbackRountes: Routes = [
  { path: ':urlname', component: FeedbackComponent },
]

var qrtakeawayRountes: Routes = [
  { path: ':urlname', component: QrhomeComponent },

]
var qrloyaltyRountes: Routes = [
  { path: ':urlname', component: QrhomeComponent },
];
var qrdineinRountes: Routes = [
  { path: ':urlname/:tblname', component: QrhomeComponent },

]

var qrdeliveryRountes: Routes = [
  { path: ':urlname', component: QrhomeComponent },

]
// Profile QR
var qrprofileRountes: Routes = [
  { path: ':urlname', component: ProfileqrComponent },
]
// CSProfile QR
var csprofileRountes: Routes = [
  { path: ':csqrcode', component: CsprofileqrComponent },
]
// LoyalloFeedback
var loyalloFeedbackRountes: Routes = [
//  { path: ':billno/:urlname', component: LoyallofeedbackComponent }
  { path: ':urlname', component: LoyallofeedbackComponent  },

];
// var routes: Routes = [
//  { path: 'fq/:urlname', component: LoyallofeedbackComponent  },
//  { path: 'cq/:csqrcode', component: CsprofileqrComponent },
//   { path:'pq/:urlname', component: ProfileqrComponent },
// ];

var routes: Routes = []


if (AppSettings.appname === "EMENU") {
  routes = emenuRountes;
}
else if (AppSettings.appname === "EBILL") {
  routes = ebillRountes;
}
else if (AppSettings.appname === "FEEDBACK") {
  routes = feedbackRountes;
}
else if (AppSettings.appname === "QRTAKEAWAY") {
  routes = qrtakeawayRountes;
}
else if (AppSettings.appname === "QRDINEIN") {
  routes = qrdineinRountes;
}
else if (AppSettings.appname === "QRDELIVERY") {
  routes = qrdeliveryRountes;
}
else if (AppSettings.appname === "PROFILEQR") {
  routes = qrprofileRountes;
}
else if (AppSettings.appname === "CUSTOMERQR") {
  routes = csprofileRountes;
}
else if (AppSettings.appname === "LOYALLOFEEDBACK") {
  routes = loyalloFeedbackRountes;
}


// const routes: Routes = [
//   // { path: '', component: HomeComponent },

//    { path: 'emenu/:urlname/ts/:tsname', component: HomeComponent },
//    { path: 'emenu/:urlname', component: HomeComponent },

//   // { path: 'ebill/:urlname', component: BilldetailsComponent },


//   // { path: 'feedback/:urlname', component: FeedbackComponent },
//   // { path: 'qr/:urlname', component: QrhomeComponent },
//   // { path: 'demo/:urlname', component: DemohomeComponent },
// ];

console.log(routes)
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true }), CommonModule],
  exports: [RouterModule],
})

export class AppRoutingModule { }
